module.exports = __webpack_public_path__ + "images/emoji/handbag.9ba240ab2dbcb1c9fd51.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/handbag.png
// module id = A/qf
// module chunks = 24